import { render } from "./CustomNode.vue?vue&type=template&id=d7379c94"
import script from "./CustomNode.vue?vue&type=script&lang=js"
export * from "./CustomNode.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__